import { Map } from 'immutable';
import { rewriteAssetCdnUrl } from '../../../utils/assetCdnRewrite';

export const normalizeImages = (pictures) =>
  pictures.map((pic) => {
    let large = pic.get('image_url');
    if (!large) {
      large = pic.get('large');
    }

    let medium = pic.get('image_medium_url');
    if (!medium) {
      medium = pic.get('medium');
    }

    return Map({
      large: large ? rewriteAssetCdnUrl(large) : large,
      medium: medium ? rewriteAssetCdnUrl(medium) : medium,
    });
  });

// The API exposes list pagination as response headers, which fromJS turns into
// either a header Map (axios object) or a List of [key, value] pairs
// depending on the environment — same duality storage.js handles.
export const readHeader = (headersPayload, name) => {
  if (!headersPayload || typeof headersPayload.toJS !== 'function') {
    return undefined;
  }
  const headers = headersPayload.toJS();
  const entries = Array.isArray(headers)
    ? headers
    : Object.entries(headers ?? {});
  return entries.find(
    (x) =>
      Array.isArray(x) && String(x[0]).toLowerCase() === name.toLowerCase(),
  )?.[1];
};

export const readTotalFromHeaders = (headersPayload) =>
  String(readHeader(headersPayload, 'total') ?? 0);
